window.App = window.App || {};
window.App.Services = window.App.Services || {};
window.App.Enum = window.App.Enum || {};